import { ImageResizeMode } from '@mews/enums';
import { RouterService } from '@mews/framework';
import { Optional } from '@mews/std';

export const getImageUrlOrNull =
    (imageBaseUrl: string) =>
    ({ imageId, mode = ImageResizeMode.CoverExact }: { imageId: Optional<string>; mode?: ImageResizeMode }) =>
        imageId ? RouterService.imageUrl(imageId, imageBaseUrl, { mode }) : null;
